/* eslint-disable @typescript-eslint/typedef */
const HTTP_ERROR_MESSAGE_KEYS_SOURCE = {
  noConnection: "errors.http.noConnection",
  serverError: "errors.http.serverError",
  badRequest: "errors.http.badRequest",
  unauthorized: "errors.http.unauthorized",
  forbidden: "errors.http.forbidden",
  notFound: "errors.http.notFound",
  timeout: "errors.http.timeout",
  conflict: "errors.http.conflict",
  unprocessable: "errors.http.unprocessable",
  tooManyRequests: "errors.http.tooManyRequests",
  unexpected: "errors.http.unexpected",
} as const;
/* eslint-enable @typescript-eslint/typedef */

export type HttpErrorMessageKey = (typeof HTTP_ERROR_MESSAGE_KEYS_SOURCE)[keyof typeof HTTP_ERROR_MESSAGE_KEYS_SOURCE];

export const HTTP_ERROR_MESSAGE_KEYS: typeof HTTP_ERROR_MESSAGE_KEYS_SOURCE = HTTP_ERROR_MESSAGE_KEYS_SOURCE;

/* eslint-disable @typescript-eslint/typedef */
const STATUS_TO_KEY_SOURCE = {
  400: HTTP_ERROR_MESSAGE_KEYS_SOURCE.badRequest,
  401: HTTP_ERROR_MESSAGE_KEYS_SOURCE.unauthorized,
  403: HTTP_ERROR_MESSAGE_KEYS_SOURCE.forbidden,
  404: HTTP_ERROR_MESSAGE_KEYS_SOURCE.notFound,
  408: HTTP_ERROR_MESSAGE_KEYS_SOURCE.timeout,
  409: HTTP_ERROR_MESSAGE_KEYS_SOURCE.conflict,
  422: HTTP_ERROR_MESSAGE_KEYS_SOURCE.unprocessable,
  429: HTTP_ERROR_MESSAGE_KEYS_SOURCE.tooManyRequests,
} as const satisfies Record<number, HttpErrorMessageKey>;
/* eslint-enable @typescript-eslint/typedef */

export type MappedHttpStatusCode = keyof typeof STATUS_TO_KEY_SOURCE & number;

export const STATUS_TO_KEY: Record<MappedHttpStatusCode, HttpErrorMessageKey> = STATUS_TO_KEY_SOURCE;
